<template>
  <div class="exchange-receiver-info">
    <div class="receiver-tip">
      <span>将使用当前的账号领取</span>
    </div>
    <div class="receiver-info">
      <ym-avatar class="user-avatar"
                 :avatar="avatar"
                 size="small"
      />
      <div class="user-info">
        <span class="name">{{ name }}</span>
        <span class="desc">{{ desc }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'ExchangeReceiverInfo',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      avatar: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      desc: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .exchange-receiver-info {
    margin-top: @size-medium;
  }

  .receiver-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &:after,
    &:before {
      content: '';
      position: absolute;
      width: 158px;
      height: 1px;
      background: #eee;
      top: 50%;
    }
    &:after {
      right: 0;
    }
    &:before {
      left: 0;
    }
    span {
      display: block;
      width: 318px;
      padding: @size-extra-small 0;
      box-sizing: border-box;
      border-radius: @size-small;
      font-size: @font-size-small;
      text-align: center;
      line-height: 1;
      background: @background-color-base;
      color: @color-text-lighter;
    }
  }

  .receiver-info {
    margin-top: @size-small;
    display: flex;
    align-items: center;
  }

  .user-info {
    margin-left: @size-small;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .name {
      color: @color-text-base;
      font-size: @font-size-base;
      font-weight: @font-weight-primary;
    }
    .desc {
      color: @color-text-lighter;
      font-size: @font-size-small;
    }
  }

</style>
